import PagarService from "@/services/PagarService";

export const pagar = {
  namespaced: true,
  state: {
    pagar: {},
  },
  actions: {
    getPagar({ commit }, payload) {
      return PagarService.GetPagar(payload).then(
        (pagar) => {
          return Promise.resolve(pagar);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postPagar({ commit }, payload) {
      return PagarService.PostPagar(payload).then(
        (pagar) => {
          return Promise.resolve(pagar);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putPagar({ commit }, payload) {
      return PagarService.PutPagar(payload).then(
        (pagar) => {
          return Promise.resolve(pagar);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deletePagar({ commit }, payload) {
      return PagarService.DeletePagar(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getPagarOData({ commit }, payload) {
      return PagarService.GetPagarOData(payload).then(
        (pagar) => {
          return Promise.resolve(pagar);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    estornar({ commit }, payload) {
      return PagarService.Estornar(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    pagarRegistros({ commit }, payload) {
      return PagarService.PagarRegistros(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    replicarRegistros({ commit }, payload) {
      return PagarService.ReplicarRegistros(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    renegociarRegistros({ commit }, payload) {
      return PagarService.RenegociarRegistros(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    imprimirRecibo({ commit }, payload) {
      return PagarService.ImprimirRecibo(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getRelatorio({ commit }, payload) {
      return PagarService.GetRelatorio(payload).then(
        (result) => {
          return Promise.resolve(result);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
  },
  mutations: {},
};

export default pagar;
